import { Injectable, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { RegisterUserFormService, RegisterUserService } from '../../../services';
import { openCiSnackbar, getOrCreateSnackbarContainer, closeSnackbarContainer } from '@iurban-malaga/cicerone-ui';
import { close } from 'ionicons/icons';

@Injectable({
  providedIn: 'root'
})
export class RegisterUserFormDesktopService {
  // Injected services
  private _translateService = inject(TranslateService);
  private _registerUserService = inject(RegisterUserService);
  private _registerUserFormService = inject(RegisterUserFormService);
  
  // Signals state
  private _shouldSubmitForm = signal(false);
  public shouldSubmitForm = this._shouldSubmitForm.asReadonly();

  // Setters
  setShouldSubmitForm(value: boolean): void {
    this._shouldSubmitForm.set(value);
  }
  
  // Methods
  /**
   * Returns the tooltip text for the submit button
   * @param form - The FormGroup to check
   */
  getTooltipText(form: FormGroup): string {
    return form.valid
      ? this._translateService.instant('Comenzar a planificar')
      : this._translateService.instant('Revisa los campos obligatorios antes de enviar');
  }

  /**
   * Handles the form submission logic
   * @param form - The FormGroup to submit
   * @param submitFormEmitter - The output emitter for form submission
   */
  /**
   * Triggers the submitRequested signal. The component should observe this signal and emit the output.
   */
  handleSubmit(form: FormGroup): void {
    if (form.invalid) {
      this._registerUserFormService.setMarkAllFormFieldsAsTouched(true);
      this.closeErrorFormSnackbar(); // close the previous one if it exists
      this.openErrorFormSnackbar();
    } else {
      this.closeErrorFormSnackbar();
      this._shouldSubmitForm.set(true);
    }
  }

  /**
   * Opens an error snackbar for invalid form submission
   */
  openErrorFormSnackbar(): void {
    openCiSnackbar({
      content: this._translateService.instant('Revisa los campos del formulario que son obligatorios'),
      status: 'error',
      'icon-name': 'error',
      'horizontal-position': 'end',
      'vertical-position': 'bottom',
    });
  }
  
  /**
   * Closes the error snackbar
   */
  closeErrorFormSnackbar(): void {
    const snackbarContainer = getOrCreateSnackbarContainer({
      horizontal: 'end',
      vertical: 'bottom',
    });
    
    if (!snackbarContainer) return;
    
    closeSnackbarContainer(snackbarContainer);
  } 
}
